import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { TimelineEvent } from './schemas'

export type TimelineEventsState = {
  events: { [job_id: string]: TimelineEvent[] }
}

const initialState: TimelineEventsState = {
  events: {},
}

export const timelineEventsSlice = createSlice({
  name: 'timelineEventsState',
  initialState,
  reducers: {
    nullifyData: () => initialState,

    setJobEventsList: (state, action: PayloadAction<{ timelineJobId: string; events: TimelineEvent[] }>) => {
      state.events[action.payload.timelineJobId] = action.payload.events
    },
  },
})

// Actions
export const TimelineEventsActions = timelineEventsSlice.actions

export default timelineEventsSlice.reducer
